/* Google Analytics смотрит на эту куку, чтобы начинать собирать даные */

export const CONSENT_COOKIE = 'gtm_cookie_consent';
